import { LBoxProps } from "@theme";
import React from "react";
import LBox from "./LBox";

interface DividerProps extends LBoxProps {}

const Divider = (props: DividerProps) => (
  <LBox
    backgroundColor={[
      "buttonBackgroundPrimaryLeft",
      "buttonBackgroundPrimaryRight",
    ]}
    gradientDirection="horizontal"
    height={1}
    {...props}
  />
);

export default Divider;
